import React from 'react';

// El selector de lector de tarjeta (docs/spec-caja.md D-03). Sólo aparece si hay más de uno: con
// un único lector no hay nada que elegir y el cobro igual lo manda (lo preselecciona
// `loadPosDevices`). Mismo criterio que el salón, la cafetería y retail.
export default function PosDeviceSelect({ devices, value, onChange, className = 'form-control', style, disabled }) {
  if (!Array.isArray(devices) || devices.length < 2) return null;
  return (
    <select className={className} style={style} value={value} disabled={disabled}
      aria-label="Lector de tarjeta" onChange={(e) => onChange(e.target.value)}>
      {devices.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
    </select>
  );
}
